// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-activity-container .ant-card .ant-card-body {
  padding: 0px;
}
.chat-activity-container-card {
  width: "100%";
  max-width: 600;
  margin: "auto";
  border: "none";
}
.chat-send-btn {
  background-color: #d2042d !important;
  height: 40px;
  width: 60px;
}
.chat-box-input-filed {
  display: flex;
  gap: 8px;
}
.ant-input-filled:focus {
  border-color: #d2042d !important;
}
@media (max-width: 768px) {
  .chat-activity-container-card {
    width: "100%";
    max-width: 700;
    margin: "auto";
    border: "none";
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/chat-activity-tab/ChatAndActivityTabs.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gCAAgC;AAClC;AACA;EACE;IACE,aAAa;IACb,cAAc;IACd,cAAc;IACd,cAAc;EAChB;AACF","sourcesContent":[".chat-activity-container .ant-card .ant-card-body {\n  padding: 0px;\n}\n.chat-activity-container-card {\n  width: \"100%\";\n  max-width: 600;\n  margin: \"auto\";\n  border: \"none\";\n}\n.chat-send-btn {\n  background-color: #d2042d !important;\n  height: 40px;\n  width: 60px;\n}\n.chat-box-input-filed {\n  display: flex;\n  gap: 8px;\n}\n.ant-input-filled:focus {\n  border-color: #d2042d !important;\n}\n@media (max-width: 768px) {\n  .chat-activity-container-card {\n    width: \"100%\";\n    max-width: 700;\n    margin: \"auto\";\n    border: \"none\";\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
